import React, { Component } from 'react';
import { FormGroup, Col, Row, Checkbox, Panel } from 'react-bootstrap';

import { toggleConfirmation } from '../actions';
import { confirmations } from '../config/constants';

class Confirmation extends Component {
  constructor(props){
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    const {dispatch} = this.props;
    dispatch(toggleConfirmation(e.target.value));
  }

  render() {
    const renderConfirmations = () => {
      return(
        <FormGroup>
          {this.props.confirmations.map((confirmation, index) => <Col md={12} key={index}><Checkbox checked={confirmation.status} value={confirmation.id} onChange={this.handleChange}>{index + 1}. {confirmations[confirmation.id]}</Checkbox></Col>)}
        </FormGroup>
      )
    };

    return (
      <Panel className="basic-info-panel" header="Confirmation of Application">
        <p>Please read the following information carefully and check the box for each line to verify that you have read, understand, and agree to each term.</p>
          <Row>
            {renderConfirmations()}
          </Row>
      </Panel>
    );
  };
}

export default Confirmation;